import React from 'react';
import { useNavigate } from 'react-router-dom';
import AccessibleModal from '../components/AccessibleModal';

const AccessibilityStatementPage = () => {
  const navigate = useNavigate();

  return (
    <AccessibleModal
      isOpen
      onClose={() => navigate(-1)}
      title="הצהרת נגישות"
      centerTitle
    >
      <div className="text-right space-y-4 text-brown-800">
        <p>
          אפליקציית "מי פנוי" מופעלת ומנוהלת על ידי אדם פרטי, ואינה מהווה עסק, תאגיד או גוף ציבורי. בעת הזו, האפליקציה נועדה לספק שירות חינמי לציבור לצורך קבלת הצעות להובלה, ואינה גובה תשלום ממשתמשים ואינה מניבה הכנסות.
        </p>
        <p>
          בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), תשע"ג–2013, החובה להנגיש אתר אינטרנט חלה על גופים עסקיים וציבוריים בלבד. משכך, מאחר שהאפליקציה "מי פנוי" אינה מופעלת על ידי עסק רשום או גוף מסחרי, היא פטורה מחובת הנגשה על פי דין.
        </p>
        <p>
          יחד עם זאת, אנו רואים חשיבות רבה בשירות נגיש לכולם, ונפעל בהדרגה לשפר את נגישות האתר והאפליקציה ככל שהדבר יתאפשר באמצעים סבירים.
        </p>
        <p>
          אם נתקלתם בקושי בשימוש באפליקציה או באתר, נשמח לקבל מכם פנייה באמצעות טופס הפניות הנגיש מעמוד הבית ונעשה מאמץ לטפל בפנייה בהקדם.
        </p>
        <p>
          בברכה,<br />
          צוות "מי פנוי"
        </p>
      </div>
    </AccessibleModal>
  );
};

export default AccessibilityStatementPage;
